import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Tag from 'components/Tag'
import Tooltip from 'components/Tooltip'
import { getTagInfo } from 'screens/serp/helpers/enhnacedContent'

import classes from './RatedTag.module.scss'

/** @type {import("./types").default} */
const RatedTag = ({ tagKey, skipSpecial = false, className }) => {
  const tag = getTagInfo(tagKey, { skipSpecial })
  return (
    <Tooltip title={tag.tooltip}>
      <Tag size="tiny" color="teal" disableRipple className={clsx(classes.root, className)}>
        <Icon icon={['fas', 'crown']} size={12} />
        {tag.label}
      </Tag>
    </Tooltip>
  )
}

export default RatedTag
